export const UPDATE_PREFERENCES_ERROR_MESSAGE =
  'Something went wrong, we could not save your preference. Please try again later.'

export const PROMOS_AND_OFFERS_ID = 'promos-and-offers'
